import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './termsAndConditions.module.scss';
import { TermsAndConditionsProps } from '.';
import { AppConstant, translate } from '@shalina-app/shared';
import { stripNumbering } from '../../../Authentication';

export const TermAndConditionsPage: React.FC<TermsAndConditionsProps> = () => {
  const t = translate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderListItems = (prefix: string, count: number) => {
    return Array.from({ length: count }, (_, i) => (
      <li key={i}>
  {t(AppConstant.TERMS_AND_CONDITIONS[`${prefix}_${i + 1}` as keyof typeof AppConstant.TERMS_AND_CONDITIONS])}
</li>
    ));
  };

  return (
    <div className={styles.termPage}>
      <div className="cust-container">
        <h1 className={styles.head}>{t(AppConstant.TERMS_AND_CONDITIONS.TERMS_CONDITIONS)}</h1>
        <div className={styles.termPageWrapper}>
          <h2 className={styles.title}>{t(AppConstant.TERMS_AND_CONDITIONS.TERMS_CONDITIONS)}</h2>
          <div className={styles.termsContent}>

            <section className={styles.contentSec}>
              <h4 className={styles.subHead}>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW)}</h4>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW_ONE)}</p>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW_TWO)}</p>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.OVERVIEW_THREE)}</p>
            </section>

            <section className={styles.contentSec}>
              <h4 className={styles.subHead}>{t(AppConstant.TERMS_AND_CONDITIONS.CHANGES_TO_TERMS_OF_USE)}</h4>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.CHANGES_TO_TERMS_OF_USE_ONE)}</p>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.CHANGES_TO_TERMS_OF_USE_TWO)}</p>
            </section>

            <section className={styles.contentSec}>
            <h4 className={styles.subHead}>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES)}</h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_ONE)}</p>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_TWO)}</p>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_THREE)}</p>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_FOUR)}</p>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_SERVICES_FIVE)}</p>

            <p>{t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST)}</p>
            <ol>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_ONE))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_TWO))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_THREE))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_FOUR))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_FIVE))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_SIX))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_SEVEN))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_EIGHT))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_NINE))}</li>
              <li>{stripNumbering(t(AppConstant.TERMS_AND_CONDITIONS.CHECKLIST_TEN))}</li>
            </ol>

            <p>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION)}</p>
            <ol>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_ONE)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_TWO)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_THREE)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.ACTION_FOUR)}</li>
            </ol>
          </section>

          <section className={styles.contentSec}>
                <h4 className={styles.subHead}>
                  {t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE)}
                </h4>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE_ONE)}</p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE_TWO)}</p>
                <p>{t(AppConstant.TERMS_AND_CONDITIONS.COPYRIGHT_NOTICE_THREE)}</p>
              </section>

              <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_INFORMATION)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.USE_OF_INFORMATION_TEXT)}</p>
          </section>
          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.MEDICAL_INFORMATION)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.MEDICAL_INFORMATION_TEXT)}</p>
          </section>
          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.VIDEO_DISCLAIMER)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.VIDEO_DISCLAIMER_TEXT)}</p>
          </section>

          <section className={styles.contentSec}>
                <h4 className={styles.subHead}>
                {t(AppConstant.TERMS_AND_CONDITIONS.INFORMATION_CAPTURED_THROUGH_THE_SERVICES)}
              </h4>
                <p>
                {t(AppConstant.TERMS_AND_CONDITIONS.INFORMATION_CAPTURED_THROUGH_THE_SERVICES_TEXT)}
              </p>
              <p>
                {t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST)}
              </p>
                <ul>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST_ONE)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST_TWO)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.PURPOSE_CHECKLIST_THREE)}</li>
              </ul>
              <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.CONSENT)}
              </h4>
              <ul>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_ONE)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_TWO)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_THREE)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_FOUR)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_FIVE)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_SIX)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_SEVEN)}</li>
                <li>{t(AppConstant.TERMS_AND_CONDITIONS.CONSENT_EIGHT)}</li>
              </ul>
              </section>
              <section className={styles.contentSec}>
              <h4 className={styles.subHead}>
                {t(AppConstant.TERMS_AND_CONDITIONS.PRIVACY_POLICY)}
              </h4>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.PRIVACY_POLICY_TEXT)}</p>
          </section>
            <section className={styles.contentSec}>
              <h4 className={styles.subHead}>{t(AppConstant.TERMS_AND_CONDITIONS.LAWS_THAT_GOVERN_THIS_AGREEMENT)}</h4>
              <p>{t(AppConstant.TERMS_AND_CONDITIONS.LAWS_THAT_GOVERN_THIS_AGREEMENT_TEXT)}</p>
            </section>

            <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_AND_MODIFICATION)}
            </h4>
            <p>
              {t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_AND_MODIFICATION_TEXT)}
            </p>
            <ul>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_ONE)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_TWO)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_THREE)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_FOUR)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_FIVE)}</li>
              <li>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_REASON_SIX)}</li>
            </ul>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.TERMINATION_CONSENT)}</p>
          </section>

          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.LIABILITY)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.LIABILITY_TEXT_ONE)}</p>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.LIABILITY_TEXT_TWO)}</p>
          </section>


          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.WARRANTY_DISCLAIMER)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.WARRANTY_DISCLAIMER_ONE)}</p>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.WARRANTY_DISCLAIMER_TWO)}</p>
          </section>


          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.INDEMNITY)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.INDEMNITY_TEXT)}</p>
          </section>

          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.ACCEPT_TERMS_OF_SERVICE)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.ACCEPT_TERMS_OF_SERVICE_TEXT)}</p>
          </section>

          <section className={styles.contentSec}>
            <h4 className={styles.subHead}>
              {t(AppConstant.TERMS_AND_CONDITIONS.AMMENDMENT_OF_TERMS_OF_USE)}
            </h4>
            <p>{t(AppConstant.TERMS_AND_CONDITIONS.AMMENDMENT_OF_TERMS_OF_USE_TEXT)}</p>
          </section>

          </div>
        </div>
      </div>
    </div>
  );
};
